module.exports = __webpack_public_path__ + "img/img2.42349c37.jpg";